module.exports = __webpack_public_path__ + "static/img/12areaB_13.ee2bd43.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_13.png
// module id = 1114
// module chunks = 1